export default "__VITE_ASSET__FNjIsjaj__"